import React, { Component } from 'react';
import   SideNav from "../sidenav/sidenav.js"
import "./eventform.css"
import  AuthService  from "../api/authentication.js";
// import   Ticket  from "./ticket.js"
import   BuildForm  from "./frombuild.js"
import  Moble from "../sidenav/moble.js"
import Test from "./test.js"
// import  Image  from "./image.js"
import { ToastContainer, toast } from 'react-toastify';
import qs from 'query-string';
// import 'react-toastify/dist/ReactToastify.css';
// import FileBase64 from 'react-file-base64';
import axios from 'axios' 


import {
    Redirect , Link 
  } from 'react-router-dom'
//   https://uvune-events.herokuapp.com
  const endpoint = 'https://uvune-events.herokuapp.com/upload-logo'
const Auth = new AuthService();
class Eventform extends Component {
  
    constructor(props){
        super(props)
        this.state = {
            loading : false,
            errorend  : false,
            noticeMassage : "",
            noerorrpage :  true,
            sendTo : false,
            allPeople : false,
            closeAllbutton : true,
            typeForm : "",
            payment_id :"",
            page:[],
            showimage:false,
            saveupDate : false,
            selectedFile: null,
            loaded: 0,
            loadingTerms : false,
            image : "",
            files: [],
            terms:false,
            Ifterms : false,
            termsError : false,
            termsMS :"",
            file: '',
            imagePreviewUrl: '',
            domain: 'https://uvune-events.herokuapp.com'
 
        }

     
    }

    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        const { match: { params } } = this.props;
        // console.log("params.userId",params.id, "params all", params)
               
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
        };
        this.setState({
         loading:true
        })
       if(this.props.location.state){
        // console.log("public users param", params.id, this.props.location.state, this.props.location.state.message)
       }else{

           
        fetch(this.state.domain+"/payment-item/"+params.id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
        //  console.log("public users", result)
          if(result.type === "FM"){
            if(result.form_schema){
                if(result.form_schema.elements  === undefined || result.form_schema.elements.length == 0){
                    
                    this.setState({
                        datapayment:result,
                        typeForm : result.type,
                        payment_id : result._id,
                        // page: result.form_schema,
                        loading:false,
                        saveupDate : true
                    })
                    // console.log("public users fisrt yes", this.state.page)
                }else{
                    this.setState({
                        datapayment:result,
                        typeForm : result.type,
                        payment_id : result._id,
                        loading:false,
                        page: result.form_schema.elements,
                        saveupDate : true
    
                    })
                    // console.log("public users fisrt no", this.state.page)
                }
                
            }else{
                this.setState({
                    datapayment:result,
                    typeForm : result.type,
                    payment_id : result._id,
                    // page: result.form_schema,
                    loading:false,
                    saveupDate : true
                })
                // console.log("public users fisrt no", this.state.page)
            }
          }else{
               this.setState({
                    datapayment:result,
                    typeForm : result.type,
                    payment_id : result._id,
                    loading:false,
                    page: result,
                    saveupDate : true

                })
          }
               
        })

        // console.log("public users fisrt", this.state.page)
    }


       }
    

    getFiles(files){
        this.setState({ 
             Ifterms : true,
             files: files,
             image : files.base64,
            loaded: 0,
         })

        //  console.log("public users fisrt", this.state.image)
      }

    
      _handleImageChange(e) {
        e.preventDefault();
    
        let reader = new FileReader();
        let file = e.target.files[0];

        this.setState({
            file: file,
            Ifterms : true
          });

        

      }
  


    

    _handleSubmit(e) {
        e.preventDefault();
          this.setState({
              loadingTerms:true
          })
        // console.log("jdtbgkhjsdtg------>",this.state.image)

        const formData = new FormData();
        formData.append('uri', this.state.file)
        //console.log("file upload.....",this.state.file)
        formData.append('terms_upload', true);
        formData.append('payment_item_id', this.state.payment_id);
        const options = {
            method: 'POST',
            headers: { 
                'content-type': 'multipart/form-data',
            'access-control-allow-origin': '*',
            'Authorization': Auth.getToken(), 
            },
            url:this.state.domain+"/upload-logo",
        };
            // console.log("data ----====>",options )
            axios.post(options.url, formData, options.headers)
              .then(res => {
                // console.log(res.statusText)
                //console.log(res)
               this.setState({
                   termsError : true,
                   termsMS : "Upload successful",
                   loadingTerms:false,
                   Ifterms :false
               })
               this.timeout()
              }).catch( (error) => {
                //    console.log("error==------>",error)
                   this.setState({
                     termsError : true,
                     termsMS : "Image to large",
                     loadingTerms:false,
                     Ifterms :false
                   })
                   this.timeout()
             });
  
      }




      uploadme=()=>{
        // console.log("dataURL 00999>>",   this.state.image )
      }

      ShowTerms=(event)=>{
            event.preventDefault
        this.setState({
            terms : true
        })
      }

      closallShow=(event)=>{
        event.preventDefault
        this.setState({
            showimage : false,
            terms :false

        })
      }




    addTopage=(data)=>{
        // console.log("data------>",   data)
        
        const   page = this.state.page
       
          page.push(data)
       this.setState({
           page  ,
           saveupDate : false,
                })
        // console.log("page data----->", page )
    }

    ShowImage=(e)=>{
        e.preventDefault();
      this.setState({
        showimage:true

      })
    }
    


    updatefrom =(e)=>{
        // console.log("data------>",this.state.page )
        const dataedit ={ 
            form_schema    :{ 
                type: "pane",
                elements:  this.state.page
            
            }
        }
        const requestOptions = {
            method: 'PATCH', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            body: JSON.stringify(dataedit),
        };
        fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                // console.log("organizers============ ", result)
                
                this.setState({
                    loadingTuition :false,
                    tuitions :result.data,
                    saveupDate:true,
                    errorend  : true,
                    noticeMassage : " update",
                })
                this.timeout()
            }else{
                this.setState({
                    loadingTuition :true,
                    errorend  : true,
                    noticeMassage : "update",
                }) 
                this.timeout()
            }
        }).catch( (error) => {
            //  console.log("errro", error);
            this.setState({
                errorend  : true,
                noticeMassage : "Not update",
            }) 
            this.timeout()
             
         });
    }  

    

    
imageE= (data)=>{
    // console.log("data ------>element build", data.imageerror)
    if(data){
     if(data.imageerror === "true") {
    //    console.log("data ------>element true", data)
          this.timeout()
         }else{
        //    console.log("data ------>element false 2", data)
        }
             
    }else{
    //  console.log("data ------>element false 1", data)
    }
   }

   TicketUpdate=(data )=>{
    // console.log("data------>",this.state.page )
  
    const requestOptions = {
        method: 'PATCH', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        body: JSON.stringify(data),
    };
    fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
    .then(res => res.json())
    .then((result)=>{
        if(result){
            // console.log("organizers============ ", result)
            
            this.setState({
                loadingTuition :false,
                tuitions :result.data,
                saveupDate:true,
                errorend  : true,
               noticeMassage : "    Update",
            })
        }else{
            this.setState({
                loadingTuition :true,
                errorend  : true,
               noticeMassage : "Update"
            }) 
            this.timeout()
        }
    }).catch( (error) => {
        //  console.log("errro", error);
        this.setState({
            errorend  : true,
            noticeMassage : "Not update",
        }) 
        this.timeout()
         
     });
   }
    
   timeout() {
     setTimeout(function() {
    //    this.setState({ imageshow:false})
      this.setState({
        showimage:false,
        errorend  : false,
        termsError : false
      })
    //    console.log("time out",this.state.showimage);
     }.bind(this), 4000);
   }


    deleteData= (id)=>{
      this.setState({
        saveupDate : false
       }) 
    //   console.log("data dlete",id)
      const  page  = this.state.page
        const fitleredpage  =  page.filter( meassage =>{
          return meassage.id !== id
        })
        // console.log(fitleredpage)
        this.setState({page:fitleredpage})
        const dataedit ={ 
            form_schema    : this.state.page
        }
        const requestOptions = {
            method: 'PATCH', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            body: JSON.stringify(dataedit),
        };
        fetch(this.state.domain+"/payment-item/"+ this.state.payment_id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                // console.log("organizers============ ", result)
                this.setState({
                    loadingTuition :false,
                    tuitions :result.data,
                    saveupDate : false,
                    errorend  : true,
                    noticeMassage : " delete",
                })
            }else{
                this.setState({
                    loadingTuition :true
                }) 
            }
           this. timeout()
        }).catch( (error) => {
            //  console.log("errro", error);
            this.setState({
                errorend  : true,
                noticeMassage : "Not delete",
            }) 
            this. timeout()
             
         });

    }


    logout = () =>{
   
        this.props.logout()
      }
    render() {
    
        //  console.log("cheking---------tui", this.props.enterme)
       return (
  
          this.state.submitIftrue ? (                 
              <Redirect to={{    pathname: `${'/info'}`  }}/>
         ):
          !this.props.isAuthenticated ? (
            <div className="hero is-bold is-fullheight">
                <div className="level-item">
                <a className="button is-loading is-large is-light">Loading</a>
                </div>
                <div className="level-item">
                <span>Trying to login...</span>
                </div>
            </div>
             )
               :
              <div className="Tuition"> 
                 <div className="Activity-moble-nav-body">
                      < Moble  logout={this.logout}/>
                 </div>     
                      <SideNav vanImage={this.props.organizer.image_url} email={this.props.user.email} 
                      logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name}
                      organizers404={this.props.organizers404}
                      /> 
            
                     <div className="main"> 
                            <div className="topright">
                                {
                                    this.state.errorend  ?
                                    <div className="notice-cos-tuition">
                                        {this.state.noticeMassage}
                                    </div> :
                                    <span> </span> 
                                }  
                            </div>
                         <div>
                     
                         <div>
                            
                                 <div className="columns">
                            <div className="column is-two-thirds">
                            <br/>
                                <div className="build-image-form-body">
                                <article className="message is-info">
                                                <div className="message-header">
                                                    <p>Build A Form</p>
                                                    {/* <button className="delete" aria-label="delete"></button> */}
                                                </div>
                                                <div className="message-body">
                                                {
                                                            !this.state.showimage?
                                                            <div>
                                                            {
                                                                
                                                                !this.state.page ? 
                                                                <p>No Form </p>  
                                                            
                                                            :
                                                            <div className="Build-list-body">
                                                            {
                                                                this.state.page.map(element=>{
                                                                                            
                                                                            return(
                                                                                <Test
                                                                                    key={element.id}
                                                                                    data={element}
                                                                                    deleteData= {this.deleteData}
                                                                                />
                                                                            
                                                                            )

                                                                        }) 
                                                            
                                                                    }
                                                        </div>
                                                            } 

                                                            {/* <div className="build-testing-list-body"> </div> */}

                                                            <div>
                                                            {/* <hr/> */}
                                                        
                                                            {
                                                                this.state.page === undefined || this.state.page.length == 0 ?
                                                                        <div>
                                                                        </div>
                                                                        :
                                                                        <div> 
                                                                            {
                                                                                 this.state.saveupDate ?
                                                                                   <div>
                                                                                   {
                                                                                       this.state.datapayment ?
                                                                                          <Link  to={'/events/'+this.state.datapayment._id} >Back To Event</Link>
                                                                                     :
                                                                                         <p> </p>
                                                                                   }
                                                                                  </div>   
                                                                                   
                                                                                    :
                                                                                    <div>
                                                                                        <hr/>
                                                                                        <button className="button is-primary is-rounded" onClick={this.updatefrom }> <i className="fas fa-save icon-link"></i> Save</button>
                                                                                    </div>
                                                                                    
                                                                                }
                                                                        </div>
                                                                }
                                                            </div>      
                    
                                                        </div>
                                                            :
                                                            <div></div>
                                                 }
                                                </div>
                                    </article>
                               
                                   
                                      
                                    
                                
                                
                                     
                                  
                                   
                                   
                               </div>
                               
                                  
                                      
                                    
                                
                                </div>
                                <div className="column">
                                    <BuildForm   addTopage={this.addTopage} 
                                    
                                    />

                                </div>
                          
                         </div>
                        
                         
                        </div>    
                       
                   </div>
                 </div>  
              </div>
        )

    }
    
    
    
    
    
    }
    
    export default Eventform;    


// WEBPACK FOOTER //
// ./src/component/create/eventform.js